import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {WizardEnums} from '../wizard.namespace';

/**
 * Сервис для управления визардом
 */

@Injectable()
export class WizardControlService {
    private _activateStep$ = new Subject<WizardEnums.Steps>();

    public activateStep$ = this._activateStep$.asObservable().pipe();

    activateStep(step: WizardEnums.Steps) {
        this._activateStep$.next(step);
    }
}
